import './style.scss';

interface MapControlGroupProps {
    children: React.ReactNode;
}

export function MapControlGroup({children}: MapControlGroupProps) {
    return <div className={`map_control_group`}>{children}</div>;
}
